export const FETCH_ORGS_LITE = 'FETCH_ORGS_LITE' as 'FETCH_ORGS_LITE';
export const FETCH_ORGS_LITE_SUCCESS = 'FETCH_ORGS_LITE_SUCCESS' as 'FETCH_ORGS_LITE_SUCCESS';
export const FETCH_ORGS_LITE_FAIL = 'FETCH_ORGS_LITE_FAIL' as 'FETCH_ORGS_LITE_FAIL';
export const FETCH_ORGS_LITE_CANCEL = 'FETCH_ORGS_LITE_CANCEL' as 'FETCH_ORGS_LITE_CANCEL';
